export const STAGE_LABELS = {
  signup_completed: 'Account created',
  profile_completed: 'Profile completed',
  portfolio_snapshot_saved: 'Portfolio snapshot saved',
  portfolio_fit_revealed: 'Portfolio fit revealed',
  portfolio_fit_paywall_clicked: 'Portfolio paywall opened',
  protected_decision_completed: 'First protected decision',
  paywall_viewed: 'Paywall viewed',
  checkout_started: 'Checkout started',
  checkout_completed: 'Checkout completed',
  checkout_failed: 'Checkout failed',
  checkout_cancelled: 'Checkout cancelled',
  restore_started: 'Restore started',
  restore_completed: 'Restore completed',
  restore_failed: 'Restore failed',
};

export const humanize = value => String(value || 'unknown')
  .replace(/[_-]+/g, ' ')
  .replace(/\b\w/g, letter => letter.toUpperCase());

export const formatHours = value => {
  if (value === null || value === undefined) return '—';
  if (value < 24) return `${value}h`;
  return `${Number((value / 24).toFixed(1))}d`;
};
